import { render, staticRenderFns } from "./TreeCategoria.vue?vue&type=template&id=62dce1a4&scoped=true&"
import script from "./TreeCategoria.vue?vue&type=script&lang=js&"
export * from "./TreeCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dce1a4",
  null
  
)

export default component.exports